import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import page from './modules/page'
import cruise from './modules/cruise'
import booking from './modules/booking'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    
  },
  actions: {},
  mutations: {},
  modules: {
    user,
    page,
    cruise,
    booking
  }
})
